import { type UseLiveActivity } from './useLiveActivity.types';

/**
 * NOTE: Live activities widget is iOS only.
 */
export const useLiveActivity: UseLiveActivity = () => {
  return {
    isFeatureEnabled: false,
    provider: 'braze',
    startLiveActivity: undefined,
    cancelLiveActivity: undefined,
    cancelAllLiveActivities() {
      return undefined;
    },
    checkLiveActivitiesStatus: () => 'not-supported',
  };
};
